import styled from 'styled-components';

export const Content = styled.div`
  .buttonWrapper {
    display: flex;
    width: 100%;
    grid-gap: 10px;
    padding: 20px 0 0;
  }

  .inputWrapper {
    display: flex;
    flex-direction: column;
    grid-gap: 20px;
  }

  .note-text {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15.6px;
    color: var(--color-text-muted);
    margin-top: 15px;
    margin-bottom: 10px;
  }
`;
